/**
 * RT ROIDescription format for SUV / PSMA-VOL (RECIP 1.0).
*/
import { math } from '../dicom-measurement/src';
import { SUV_METHOD_VERSION } from '../dicom-measurement/src/suv/suvSampleCache';
import { PSMA_METHOD_VERSION } from '../dicom-measurement/src/suv/psmaVolume';
 
const { round } = math;

export const ROI_DESCRIPTION_MAX_LENGTH = 1024;  //DICOM VR ST: at most 1024 characters.

const SUV_KEYS = ['max', 'mean', 'min', 'sd'];
const PSMA_KEYS = ['bone_thres', 'bone_vol', 'soft_tissue_thres', 'soft_tissue_vol'];

const round2 = (v) => (v == null ? null : round(v, -2));

function roundFields(obj, keys) {
  if (!obj) return null;
  return keys.reduce((out, k) => ({ ...out, [k]: round2(obj[k]) }), {});
}

export function toDescriptionFields(entry) {
  const suv = roundFields(entry?.suv, SUV_KEYS);
  return {
    suv: suv,
    psma_volume: suv ? roundFields(entry?.psma_volume, PSMA_KEYS) : null,
    suv_method: SUV_METHOD_VERSION,
    psma_method: PSMA_METHOD_VERSION,
  };
}

const isNumberOrNull = (v) =>
  v === null || (typeof v === 'number' && Number.isFinite(v));

function pickNumbers(obj, keys) {
  if (obj === null) return null;
  if (!obj || typeof obj !== 'object') return undefined;
  if (!keys.every((k) => isNumberOrNull(obj[k]))) return undefined;
  return keys.reduce((out, k) => ({ ...out, [k]: obj[k] }), {});
}

export function parseStoredSuv(description) {
  if (!description || typeof description.suv_method !== 'string') return undefined;
  const suv = pickNumbers(description.suv, SUV_KEYS);
  const psma_volume = pickNumbers(description.psma_volume, PSMA_KEYS);
  if (suv === undefined || psma_volume === undefined) return undefined;
  return {
    suv,
    psma_volume,
    suv_method: description.suv_method,
    psma_method:
      typeof description.psma_method === 'string' ? description.psma_method : null,
  };
}